import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/web.timers.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-cf39223a"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("strong", null, "系统消息", -1);
});
import { ref, onMounted } from 'vue';
export default {
  __name: 'Toast',
  props: {
    message: {
      type: String,
      required: true
    },
    type: {
      type: String,
      "default": 'success',
      // 默认状态为成功
      validator: function validator(value) {
        return ['success', 'error', 'warning'].includes(value);
      }
    },
    duration: {
      type: Number,
      "default": 3000 // 默认3秒后消失
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var visible = ref(true);
    var hideToast = function hideToast() {
      visible.value = false;
    };
    onMounted(function () {
      setTimeout(hideToast, props.duration);
    });
    return function (_ctx, _cache) {
      return visible.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        "class": _normalizeClass(['toast', __props.type]),
        onClick: hideToast
      }, [_hoisted_1, _createElementVNode("p", null, _toDisplayString(__props.message), 1)], 2)) : _createCommentVNode("", true);
    };
  }
};